'use strict';

module.exports = require('./src/angular-input-masks.us');



//////////////////
// WEBPACK FOOTER
// ../~/angular-input-masks/us.js
// module id = 35
// module chunks = 3